<template>
  <v-card
    class="pa-5"
    v-if="commentsData"
    :style="{ border: '1px solid var(--primary-boarder-color)' }"
  >
    <v-row class="mb-2 pa-5 pb-1 ">
      <span class="text-h6 font-weight-bold"
        >Comments ({{ commentsData.length }})</span
      >
    </v-row>
    <v-divider class="border-opacity-25"></v-divider>
    <v-list class="comment-list" v-if="commentsData && commentsData.length > 0">
      <v-list-item-group
        v-for="(comment, index) in commentsData"
        :key="index"
        active-class="bg-white"
      >
        <v-list-item three-line>
          <v-list-item-avatar>
            <v-avatar>
              <img
                v-if="comment.user.profile_image"
                :src="comment.user.profile_image"
              />
              <img v-else :src="defaultImage" />
            </v-avatar>
          </v-list-item-avatar>
          <v-row
            class="mb-2 pa-5 pb-1 d-flex justify-space-between align-center"
          >
            <v-list-item-content>
              <v-list-item-title class="comment-user-name font-weight-bold">
                <span v-if="comment.user && comment.user.name">{{
                  comment.user.name
                }}</span>
                <span v-else>Unknown User</span>
              </v-list-item-title>
              <v-list-item-subtitle
                class="font-weight-light"
                v-html="formatDateString(comment.created_at)"
              ></v-list-item-subtitle>
              <p
                class="comment-text text-md-h6 font-weight-light"
                v-html="comment.comment"
              ></p>
            </v-list-item-content>
            <v-menu offset-y>
              <template
                v-if="comment.auth_permission == 1"
                v-slot:activator="{ on, attrs }"
              >
                <v-icon v-on="on" v-bind="attrs" class="menu-icon"
                  >mdi-dots-vertical</v-icon
                >
              </template>
              <v-list class="menu-list" v-if="comment.auth_permission == 1">
                <v-list-item
                  @click="deleteComment(comment.uuid, comment.auth_permission)"
                >
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-list-item>
        <v-divider v-if="index < commentsData.length - 1"></v-divider>
      </v-list-item-group>
    </v-list>
    <v-row v-else class="d-flex align-center justify-center">
      <img class="comment-empty-image" :src="emptyComment" />
    </v-row>
    <v-row>
      <v-text-field
        v-if="hasPermission('project.message')"
        class="rounded-btn"
        v-model="newComment"
        label="Add a new comment"
        height="55"
        outlined
        solo
        flat
        style="border-radius: 12px;"
      ></v-text-field>
      <div class="small-gap"></div>
      <v-btn
        v-if="hasPermission('project.message')"
        @click="addComment"
        color="var(--color-light-blue)"
        class="rounded-btn"
        height="55"
        text
      >
        <v-icon>mdi-send</v-icon>
      </v-btn>
    </v-row>
  </v-card>
</template>

<style scoped>
.comment-list {
  height: 440px;
  overflow-y: auto;
  position: relative;
}

.comment-user-name {
  color: #000000;
}

.comment-text {
  color: #707070;
}

.menu-icon {
  position: absolute;
  top: 35px;
  right: 20px;
  cursor: pointer;
}

.rounded-btn {
  border-radius: 12px;
  padding: 0;
  margin: 0;
}

.small-gap {
  width: 8px;
}

.comment-empty-image {
  max-height: 435px;
  min-height: 435px;
}
</style>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
export default {
  props: {
    commentsData: Array,
  },

  data: () => ({
    defaultImage: require("@/assets/img/avatar.svg"),
    emptyComment: require("@/assets/img/empty_comments.svg"),
    comments: [],
    newComment: "",
  }),

  methods: {
    addComment() {
      this.$emit("add-comments", this.newComment.trim());
      this.newComment = "";
    },
    deleteComment(uuid, authPermission) {
      this.$emit("delete-comments", uuid, authPermission);
    },
    editComment(uuid) {
      console.log(uuid);
    },
    formatDateString(inputDateString) {
      const inputDate = new Date(inputDateString);

      const options = {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      return inputDate.toLocaleString("en-US", options);
    },
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
};
</script>
